import { useQuery } from '@tanstack/react-query';
import { Account } from '#types/account';
import { fetcher } from '../libs';
import queryKeys from '../queryKeys';

export default function useMyAccountQuery() {
  return useQuery([queryKeys.ACCOUNT, 'me'], () =>
    fetcher<Account>('/accounts')
  );
}
